/** One desktop ticket attempt; the viewer owns the entire retry episode. */
import { z } from 'zod';

const ticketSchema = z.object({
  url: z.string().min(1),
  expiresAt: z.number().int().positive(),
  width: z.number().int().positive(),
  height: z.number().int().positive(),
  credentials: z.object({ password: z.string().min(1).max(8) }).optional(),
});

/** The callback must perform a single fetch, never REST restart recovery or another scheduler. */
export async function requestDesktopTicket(request: () => Promise<unknown>): Promise<z.infer<typeof ticketSchema>> {
  return ticketSchema.parse(await request());
}
